import React from 'react';
import { useForm } from "react-hook-form";
import emailjs from 'emailjs-com';
import { Col, Container, Row } from 'react-bootstrap';
import contact from '../../../images/contact/contact.png';
import './Contact.css';



const Contact = () => {
    const { register} = useForm();

    const sendEmail = (e) => {
        e.preventDefault();
          
        emailjs.sendForm('service_ndxrcsf', 'template_975njce', e.target,'user_9PtveqoupTZwi34BaHAaL' )
        .then(res=> {
           alert('Your Message Send Successfully')

        })
        .catch(err =>console.log(err));
    }


    return (
        <section id="contact">
            <Container className='container-cont'>
                <div className="contact">
                <Row>
                    <Col lg={5} md={4} sm={12}>
                        <div className='cont-img my-4'>
                            <img src={contact} alt="" />
                        </div>
                    </Col>

                    <Col lg={7} md={8} sm={12}>
                    <form onSubmit={sendEmail} className='my-4'>
                        <input className="bg-white mt-5" {...register("name", { required: true, maxLength: 25 })} placeholder="Enter Name" />
                        <input className="my-2 bg-white" {...register("user_email")} placeholder="Email" />
                        <textarea className="my-3 bg-white" {...register("message")} row="3" placeholder="Message" />
                        <button className="my-2 send-btn" type="submit">SEND</button>
                    </form>
                    </Col>
                </Row>
                </div>
            </Container>

                <footer className="sub-footer">
                    <small>Frontend &copy; 2018 &#9877; DILRUBA BORNA</small>
                    <br />
                    <small>Dhaka, Bangladesh</small>
                </footer>
                    
        </section>
    );
};

export default Contact;



                

        